import {
  useContext,
  useState,
  cloneElement,
  useEffect,
  forwardRef,
} from "react";
import { TreeContext } from "pages/Editor";
import { onReturnKey } from "./helpers";

function ContentEditable({ children, path, value }, ref) {
  const { update, selection } = useContext(TreeContext);
  const [editing, setEditing] = useState(false);
  const onKeyDown = (e) => {
    onReturnKey(() => {
      setEditing(false);
      update(path + ".value", e.target.innerText);
    })(e);
  };
  const onDoubleClick = (e) => {
    e.preventDefault();
    setEditing(true);
  };
  const onClick = (e) => {
    if (selection) {
      if (selection.path !== path) return;
    } else return;
    // prevent unselecting during double click
    e.stopPropagation();
  };
  const onBlur = () => setEditing(false);
  useEffect(() => {
    if (editing) ref.current.focus();
  }, [editing, ref]);
  useEffect(() => {
    if (ref.current) ref.current.innerText = value;
  }, [ref, value]);
  return cloneElement(children, {
    ref,
    onKeyDown,
    onDoubleClick,
    onClick,
    onBlur,
    contentEditable: editing,
  });
}
export default forwardRef(ContentEditable);
